export var Status = {
  Success: 'success',
  Info: 'info',
  Error: 'error',
  Warning: 'warning'
};